import CircularLoading from '@/components/circular-loading';
import InvestmentService from '@/services/Investment.service';
import { ProgramService } from '@/services/ops/investments/Program.service';
import { useQuery } from '@tanstack/react-query';

import { FC } from 'react';
import { useParams } from 'react-router-dom';

import { ProgramChangeReviewPage } from './ProgramChangeReviewPage.component';

const ProgramChangeReviewRoute: FC = () => {
  const urlParams = useParams<{ programChangeId: string; planId: string }>();

  const programChange = useQuery(
    [
      'ProgramService.getProgramChangeReenrollmentById',
      +urlParams.programChangeId,
      +urlParams.planId
    ],
    () =>
      ProgramService.getProgramChangeReenrollmentById(
        +urlParams.programChangeId,
        +urlParams.planId
      ),
    {
      refetchOnMount: 'always',
      staleTime: Infinity
    }
  );

  const planQuery = useQuery(
    ['InvestmentService.getPlanFunds', 'plan', +urlParams.planId],
    () =>
      InvestmentService.getPlanFunds(
        +urlParams.planId,
        programChange.data.newProgramId
      ),
    { cacheTime: 0, enabled: !!programChange.data }
  );

  if (programChange.isLoading || planQuery.isLoading) {
    return <CircularLoading />;
  }

  return (
    <ProgramChangeReviewPage
      currentProgram={planQuery.data.currentProgram}
      newProgram={planQuery.data.newProgram}
      programChange={programChange.data}
    />
  );
};

export default ProgramChangeReviewRoute;
